import { render } from "./TextButton.vue?vue&type=template&id=62b2ad34&scoped=true&ts=true"
import script from "./TextButton.vue?vue&type=script&lang=ts"
export * from "./TextButton.vue?vue&type=script&lang=ts"

import "./TextButton.vue?vue&type=style&index=0&id=62b2ad34&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b2ad34"]])

export default __exports__